var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.companies
    ? _c(
        "f7-list",
        {
          staticClass: "searchbar-found",
          attrs: { "media-list": "", id: "companies-list" },
        },
        [
          _c(
            "f7-list-item",
            [
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "text-center font-weight-bold" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("administration.user_id") + " :") +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-col", { staticClass: "text-center font-weight-bold" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("administration.company_number") + " :") +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-col", { staticClass: "text-center font-weight-bold" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("administration.company_name") + " :") +
                        "\n      "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.companies, function (companiesGroup, key) {
            return _c(
              "f7-list",
              { key: key, attrs: { "media-list": "" } },
              [
                _c("f7-list-item", {
                  attrs: { title: key, "group-title": "" },
                }),
                _vm._v(" "),
                _vm._l(companiesGroup, function (company) {
                  return _c(
                    "f7-list-item",
                    { key: company.Id, staticClass: "boxRequest" },
                    [
                      _c(
                        "b-row",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.seeDetails(company)
                            },
                          },
                        },
                        [
                          _c("b-col", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n          " + _vm._s(company.Id) + "\n        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("b-col", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(company.Login) +
                                "\n        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("b-col", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(company.Name) +
                                "\n        "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
              ],
              2
            )
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }